import { RestError } from "../../services/rest-service/RestService";
import { useQuery } from "react-query";
import { IOrganization } from "../../services/organization-data-service/Models";
import OrganizationDataService from "../../services/organization-data-service/OrganizationDataService";
import { BaseUseQueryParameters } from "../BaseUseQueryParameters";
import { keys } from "./Keys";
import { eLynxObjectTypeEnum } from "../../common/enums/eLynxObjectType";

export type UseOrganizationParameters = {
    includeAllOption?: boolean;
} & BaseUseQueryParameters<IOrganization[] | undefined>;

export function useOrganizations({
    includeAllOption,
    onError,
    onSuccess,
    refreshSeconds
}: UseOrganizationParameters) {
    return useQuery<IOrganization[], RestError>(
        keys.organizations(includeAllOption),
        async ({ signal }) => {
            //return OrganizationDataService.getOrganizations(signal);

            const data = await OrganizationDataService.getOrganizations(signal);

            if (includeAllOption) {
                const root = data.find(o => !o.parentID);
                if (root) {
                    root.parentID = -1;
                }
                data.unshift({
                    //parentID: null,
                    id: -1,
                    objectType: eLynxObjectTypeEnum.Organization,
                    displayText: 'All Organizations',
                    objectName: 'All Organizations'
                } as IOrganization)
            }

            return data;
        },
        {
            onError: onError,
            onSuccess: onSuccess,
            refetchInterval: refreshSeconds ? refreshSeconds * 1000 : false
        }
    );
}
